import type * as React from "react";

import { connect } from "react-redux";

import { shortMonthAndYear } from "@similarweb/pro-logic-components";

import { capitalizeIntent } from "app/pages/keyword-research/keyword-analysis/pages/keyword-generator/google-keyword-generator/utils";
import { getVolumeValue } from "app/pages/website-analysis/traffic-sources/search/common/utils";
import CountryService from "app/services/CountryService";
import DurationService from "app/services/DurationService";

import {
    LABELS_FOR_TABLE_TYPES,
    TABLE_TYPES_FOR_ENDPOINT,
} from "app/common/keyword-research/keyword-generator/constants";
import {
    KeywordGeneratorToolPageTableBase,
    mapDispatchToPropsBase,
    mapStateToPropsBase,
} from "./KeywordGeneratorToolPageBase";
import { paramsWithUpdatedRangeFilterAndKeyword } from "./KeywordGeneratorToolPageTable";
import { PhraseMatchTableSettings } from "./PhraseMatchTableSettings";
import type { IGoogleKeywordGeneratorApiResponse } from "app/common/keyword-research/keyword-generator/types";

class KeywordGeneratorToolPageTrendingTable extends KeywordGeneratorToolPageTableBase {
    protected tableSettings = PhraseMatchTableSettings;
    protected tableStorageKey = "KeywordGeneratorToolRelatedTable";
    protected dropdownAppendTo = ".thirdTab .swReactTable-header-wrapper";

    protected dataParamsAdapter = (params) => {
        return {
            ...paramsWithUpdatedRangeFilterAndKeyword(params, this.props.duration),
            type: TABLE_TYPES_FOR_ENDPOINT.broad,
            label: LABELS_FOR_TABLE_TYPES.trending,
        };
    };

    protected transformData = (data: IGoogleKeywordGeneratorApiResponse) => {
        return {
            ...data,
            records: data.records.map((keywordGroupDetail) => {
                const countryName = CountryService.getCountryById(this.props.country).text;
                const durationText = DurationService.getFormattedDateOutOfDurationParam(
                    this.props.duration,
                    shortMonthAndYear,
                );
                return {
                    ...keywordGroupDetail,
                    averageVolume: getVolumeValue(keywordGroupDetail.averageVolume),
                    monthlyVolume: getVolumeValue(keywordGroupDetail.monthlyVolume),
                    windowVolume: getVolumeValue(keywordGroupDetail.windowVolume),
                    SearchTerm: keywordGroupDetail.keyword,
                    url: this.getUrlForKeyWord(keywordGroupDetail.keyword),
                    country: this.props.country,
                    countryName,
                    durationText,
                    web_source: this.props.webSource,
                    organicShare: keywordGroupDetail.paidShare === 0 ? 1 : keywordGroupDetail.organicShare,
                    intents: {
                        PrimaryIntent: capitalizeIntent(keywordGroupDetail.primaryIntent),
                        SecondaryIntent: capitalizeIntent(keywordGroupDetail.secondaryIntent),
                    },
                };
            }),
        };
    };
}

export default connect(
    mapStateToPropsBase,
    mapDispatchToPropsBase,
)(KeywordGeneratorToolPageTrendingTable as React.ComponentType<any>);
